// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/ruhsatInfo/RuhsatInfo.css
// module id = 1038
// module chunks = 0